import { MonthZeroBased } from '@deltasierra/shared';
import * as React from 'react';
import { getCalendarDates } from './get-calendar-dates';

/**
 * This hook provides a list of days in a given month, as well as some formatting for weeks and months
 *
 * @param year - the year that the month is in
 * @param month - the zero indexed number representing the desired month
 * @returns a list of days in the month, the label of the month, and the labels of the week
 */
export function useDatesInCalendarMonth(year: number, month: MonthZeroBased): Date[] {
    return React.useMemo(() => getCalendarDates(year, month), [year, month]);
}
